import React from 'react'
import { Button } from 'antd'
import FOModal from 'components/FOModal/index'
import logoIcon from './images/noom-fiton-logo.png'
import { styles } from './index.module.scss'
import { setAppFirstOpen } from 'utils/wwLocalStorage'

export const InterstitialModal = (props) => {
  const { visible, setVisible } = props

  return (
    <FOModal
      visible={visible}
      setVisible={setVisible}
      className={styles}
      center={true}
    >
      <div className='modal-header'>
        <img src={logoIcon} alt='' className='logo-icon' />
      </div>
      <div className='modal-content'>
        1,000+ movement classes included with your subscription
      </div>
      <Button
        className='btn-primary action-btn'
        onClick={(e) => {
          e.stopPropagation()
          setVisible(false)
          setAppFirstOpen(false)
        }}
      >
        Got it!
      </Button>
    </FOModal>
  )
}
